export const USER_STATUS = {
  ACTIVE: 0,
  FORBID_BETTING: 1,
  INACTIVE: 2,
  FREEZE_MONEY: 3,
  FORBID_WITHDRAW: 4,
};

export const GAME_TYPES = ["jsc", "kuaikai", "shishi", "cn", "hot", "hk", "sports", "qipai", "dianzi"];

export const GAME_RULES = [
  {
    subtitle: "极速彩系列",
    topics: [
      { description: "极速六合彩", hash: "HK6JSC", url: "/util/rules/" },
      { description: "极速11选5", hash: "11X5JSC", url: "/util/rules/" },
      { description: "极速快3", hash: "K3JSC", url: "/util/rules/" },
      { description: "极速快乐8", hash: "KL8JSC", url: "/util/rules/" },
      { description: "极速快乐十分", hash: "KLSFJSC", url: "/util/rules/" },
      { description: "极速时时彩", hash: "SSCJSC", url: "/util/rules/" },
      { description: "极速牛牛", hash: "PK10JSCNN", url: "/util/rules/" },
      { description: "极速百家乐", hash: "BJPK10BJL", url: "/util/rules/" },
      { description: "极速蛋蛋", hash: "PCEGGJSC", url: "/util/rules/" },
      { description: "极速赛车", hash: "PK10JSC", url: "/util/rules/" },
      { description: "极速飞艇", hash: "LUCKYSB", url: "/util/rules/" },
    ],
  },
  {
    subtitle: "时时彩系列",
    topics: [
      { description: "SG时时彩", hash: "SGSSC", url: "/util/rules/" },
      { description: "以太时时彩", hash: "ETHSSC", url: "/util/rules/" },
      { description: "幸运时时彩", hash: "XYSSC", url: "/util/rules/" },
      { description: "波场时时彩", hash: "TRONSSC", url: "/util/rules/" },
    ],
  },
  {
    subtitle: "快开彩系列",
    topics: [
      { description: "SG快3", hash: "SGK3", url: "/util/rules/" },
      { description: "SG快乐8", hash: "SGKL8", url: "/util/rules/" },
      { description: "SG快乐十分", hash: "SGKLSF", url: "/util/rules/" },
      { description: "SG飞艇", hash: "SGFT", url: "/util/rules/" },
      { description: "幸运飞艇", hash: "XYFT", url: "/util/rules/" },
      { description: "澳洲幸运10", hash: "AULUCKY10", url: "/util/rules/" },
      { description: "澳洲幸运20", hash: "AULUCKY20", url: "/util/rules/" },
      { description: "澳洲幸运5", hash: "AULUCKY5", url: "/util/rules/" },
      { description: "澳洲幸运8", hash: "AULUCKY8", url: "/util/rules/" },
      { description: "PC蛋蛋", hash: "AUPCEGG", url: "/util/rules/" },
      { description: "SG11选5", hash: "SG11X5", url: "/util/rules/" },
    ],
  },
  {
    subtitle: "全国彩系列",
    topics: [
      { description: "体彩排列3", hash: "PL3", url: "/util/rules/" },
      { description: "体彩排列5", hash: "PL5", url: "/util/rules/" },
      { description: "快乐8", hash: "FKL8", url: "/util/rules/" },
      { description: "福彩3D", hash: "F3D", url: "/util/rules/" },
    ],
  },
  {
    subtitle: "香港彩系列",
    topics: [
      { description: "香港六合彩", hash: "HK6", url: "/util/rules/" },
      { description: "台湾大乐透", hash: "TWDLT", url: "/util/rules/" },
    ],
  },
];

export const getStandardizeDateTimeFormat = (datetime, dateOnly = false) => {
  var date = new Date(datetime).toLocaleString("en-US", { hour12: false }).split(" ");
  var time = date[1];
  var mdy = date[0];
  mdy = mdy.split("/");
  var month = parseInt(mdy[0]);
  var day = parseInt(mdy[1]);
  var year = parseInt(mdy[2]);

  return `${year}-${month}-${day} ${dateOnly ? "" : time} `;
};
